
import api from '../api/api';
import { Toast } from '../../components';
import staticText from '../../localization/Application/application';

const authenticateAndRedirectToHappyFox = async (clearQueryParams, organizationId) => {
  try {
    const response = await api.generateAuthenticatedHappyFoxUrl(organizationId);

    if (response && response.data && response.data.url) {
      window.location.href = response.data.url;
    } else if (response && response.data && response.data.reason) {
      // A customer on a free plan will run into this condition
      Toast(response.data.reason, 'warn');
      clearQueryParams();
    } else {
      // Throw our generic error if something unexpected happened
      throw new Error();
    }
  } catch (error) {
    Toast(staticText.happyFox.urlGenerationError, 'warn');
    clearQueryParams();
  }
};

export default authenticateAndRedirectToHappyFox;
